export const checkoutUrl =
  'https://keyfutureskills.gumroad.com/l/90-day-new-manager-toolkit?wanted=true';

export const toolkitFiles = [
  {
    label: '00 · Vault Index',
    meta: '6 pages',
    description:
      "The start-here guide. It routes you to the right file based on what's happening this week."
  },
  {
    label: 'Module A · The 90-Day Roadmap',
    meta: '29 pages',
    description:
      'A day-by-day and week-by-week plan for weeks 1, 2, 4, 8 and 12. Covers your first meetings, former-peer conversations, expectations, and fixing a bad first month.'
  },
  {
    label: 'Module B · The 1:1 Meeting System',
    meta: '20 pages',
    description:
      'Agenda templates, a situation-specific question bank, and a running tracker for every person you manage.'
  },
  {
    label: 'Module C · Delegation & Feedback Frameworks',
    meta: '15 pages · 12 one-pagers',
    description:
      'Printable one-page guides to keep open during the conversation: the situation, the framework, the words, and the common mistake.'
  },
  {
    label: 'Difficult Conversations Playbook',
    meta: '60 pages',
    description:
      'A complete companion guide for the hard conversations managers dread most.'
  },
  {
    label: 'Script Vault',
    meta: '10 templates',
    description:
      'Ready-to-send messages for the moments that happen over email or chat, not face-to-face.'
  },
  {
    label: '30-Day Hard Talk Challenge',
    meta: '30 days',
    description:
      'A structured way to practice difficult conversations until they stop feeling difficult.'
  }
];

export const faqs = [
  {
    question: 'What format are the files?',
    answer:
      'Seven printable PDF files. They are delivered as an instant digital download.'
  },
  {
    question: 'Do I need special software?',
    answer:
      'No. Any standard PDF reader works. You can use them on screen or print the pages you need.'
  },
  {
    question: 'Is this a subscription?',
    answer:
      'No. You pay $69 once. The files are yours to keep and reprint forever.'
  },
  {
    question: "What if I'm not new to management?",
    answer:
      'It is still useful if you have managed people before but never received practical training for the role.'
  },
  {
    question: 'How do I get the files after buying?',
    answer:
      'Gumroad gives you an instant download link and sends the same access link in your email receipt.'
  }
];